<template>
  <div class="tags-menu">
    <label>{{ $t('root.filters.tags') }}</label>
    <multi-select v-model='selectedTags' :getter='getTags' />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
  import _multi_select from '../../_infinite_multi_select'

  export default {
    components: {
      'multi-select': _multi_select,
    },
    data() {
      return {
        selectedTags: [],
      }
    },
    computed: {
      selectedTagIds() {
        return this.selectedTags.map(c => c.id)
      },
    },
    methods: {
      filter() {
        const newQuery = Object.assign({}, this.query, { page: 1, tags_id: this.selectedTagIds })

        this.$router.push({ query: newQuery })

        this.$emit('cancel')
      },
      getTags(params) {
        return this.listStore.getTags(params)
      },
    }
  }
</script>
<style lang="sass" scoped>
  .tags-menu
    width: 250px
    padding: 10px
    .float-right
      margin-top: 15px
    select
      margin-bottom: 10px
</style>
